<template>
  
  <el-dialog v-if="dialogVisible"  width="68%" :visible.sync="dialogVisible" @close="qx()"  title="录入" :close-on-click-modal="false" :close-on-press-escape="false">

    <el-form  :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '150px' : '150px'">
      <div v-if="dataForm.borrowerType == 'PERSONAGE'">
        <h3 class='h3'>借款人</h3>
        <div class="line-box">
          <el-form-item label="姓名"   class="styW">
              <el-input v-model="dataForm.custName" disabled placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号"  class="styW">
            <el-input v-model="dataForm.mobile" disabled placeholder="手机号" ></el-input>
          </el-form-item>
          <el-form-item label="身份证号码"  class="styW">
            <el-input v-model="dataForm.idNo" disabled placeholder="证件号码"></el-input>
          </el-form-item>
        </div>
        <div class="line-box">
          <el-form-item v-if="dataForm.payeeType == 'ENTERPRISE'" class="styW" label="对公账户银行开户名" >
            <el-input  v-model="dataForm.bankAcctname" disabled placeholder="开户名"></el-input>
          </el-form-item>
          <el-form-item  class="styW" :label="dataForm.payeeType == 'ENTERPRISE' ? '收款银行账号' : '银行卡号'" >
            <el-input  v-model="dataForm.bankCardNo" disabled placeholder="银行卡号"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="银行名称">
            <el-input  v-model="dataForm.bankName" disabled placeholder="银行名称"></el-input>
          </el-form-item>
          <el-form-item label="邮箱地址" class="styW" >
            <el-input v-model="dataForm.email" disabled  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="现住地址"   class="sandh">
            <el-input v-model="dataForm.address" disabled placeholder="请输入"></el-input>
          </el-form-item>
        </div>
  
        <el-form-item label="添加共借人" prop="productCode">
          <el-button @click="addBorrow">添加共借人</el-button>
        </el-form-item>
        <!-- 共借人添加 -->
        <el-card v-if="gjr">
          <el-form v-loading="myLoading" :model="relationList" :rules="rules"
          :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'"
          ref="relationList" >
            <el-form-item label="身份证" prop="idNo" >
              <div class="tip_upload">
              <div>
                <div class="id-upload">
          
              <el-upload
                drag
                :action="uploadUrl"
                :on-success="handleSuccessFront"
                :on-remove="handleRemoveFront"
                :on-preview="handlePreviewFront"
                :before-upload="beforeUploadFront"
              >
                <img v-if="frontUrl" :src="frontUrl" class="avatar">
                <div v-else class="id-card">
                  <div>
                    <div class="title">头像面</div>
                    <div>
                      <img src="../../../assets/img/头像面.png" alt=""  class="avatar">
                    </div>
                  </div>
                <div>
                  <div class="add">+</div>
                  <div>请上传身份证头像面图片</div>
                </div>
            </div>
          </el-upload>
          <!-- <i class="el-icon-delete deleteIcon"></i> -->
        </div>
        <div class="id-upload">
          <el-upload
            drag
            :action="uploadUrl"
            :on-success="handleSuccessBack"
            :on-remove="handleRemoveBack"
            :on-preview="handlePreviewBack"
            :before-upload="beforeUploadBack"
          >
            <img v-if="backUrl" :src="backUrl" class="avatar">
            <div v-else class="id-card">
              <div>
                <div class="title">国徽面</div>
                <div>
                  <img src="../../../assets/img/国徽面.png" alt=""  class="avatar">
                </div>
              </div>
              <div>
                  <div class="add">+</div>
                  <div>请上传身份证国徽面图片</div>
                </div>
            </div>
          </el-upload>
          <!-- <i class="el-icon-delete deleteIcon"></i> -->
        </div>
        
        <el-button type="primary" @click="idUpload">确认上传</el-button>
              </div>
              <div class="tips">
                 1.请确保借款人身份证图片所有信息清晰可见，内容真实有效，无任何修改<br>
                 2.文件大小不超过3M，格式支持 ：jpg，jpeg，png，bmp <br>
                 3.图片建议分辨率为1024*768
              </div>
            </div>
         </el-form-item>
         <div class="line-box">
          <el-form-item label="姓名" prop="name"  class="styW">
              <el-input v-model="relationList.name" disabled  placeholder="上传身份证后自动识别"></el-input>
            </el-form-item>
           
            <el-form-item label="身份证号码" prop="idNo"  class="styW">
                <el-input v-model="relationList.idNo" disabled placeholder="上传身份证后自动识别"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="mobile"  class="styW">
                <el-input v-model="relationList.mobile"  placeholder="手机号" ></el-input>
            </el-form-item>
            <el-form-item label="地址/住址" prop="addr"  class="styW">
                <el-input v-model="relationList.addr"  placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址" prop="email"  class="styW">
                <el-input v-model="relationList.email" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
            <el-form-item label="操作" >
              <el-button @click="addCancel">取消</el-button>
              <el-button @click="submitForm('relationList')" >添加</el-button>
            </el-form-item>
        </el-form>
      </el-card>

      <h3 class='h3' v-if="dataForm.relationList.length > 0">共借人</h3>
      <div class="line-box">

     <div class="line-box">
      <div class="gjr" v-for="(item,index) in dataForm.relationList" :key="item.idNo" >
          <el-form-item class="styW" label="姓名" :prop="'relationList.' + index + '.name'" :rules="{ required: true, pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文', trigger: 'blur' }">
            <el-input v-model="item.name"  disabled placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="Tel" :prop="'relationList.' + index + '.mobile'" :rules="{required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur'}">
              <el-input v-model="item.mobile"  placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="身份证号码" :prop="'relationList.' + index + '.idNo'" :rules="{ required: true,  pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }">
              <el-input  v-model="item.idNo" disabled  placeholder="证件号码"></el-input>
            </el-form-item>
          <el-form-item class="styW" label="地址/住址" :prop="'relationList.' + index + '.addr'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
              <el-input v-model="item.addr"  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item  class="styW" label="邮箱地址" :prop="'relationList.' + index + '.email'" :rules="{ required: true,type:'email', message: '请输入正确的邮箱', trigger: 'blur' }">
              <el-input v-model="item.email"  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="是否删除共借人" >
            <el-button @click="del(item.mobile)">删除</el-button>
          </el-form-item>
        </div>
      </div>
      </div>
    </div>
    <div v-if="dataForm.borrowerType == 'ENTERPRISE'">
      <h3 class="h3">借款企业</h3>
      <div class="line-box">
        <el-form-item label="企业名称"   class="styW">
              <el-input v-model="dataForm.custName" disabled placeholder="企业名称"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码"  class="styW">
            <el-input v-model="dataForm.idNo" disabled placeholder="统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="联系电话"  class="styW">
            <el-input v-model="dataForm.mobile" disabled placeholder="联系电话" ></el-input>
        </el-form-item> 
      </div>
      <div class="line-box">
          <el-form-item class="styW" label="收款银行账号" >
            <el-input  v-model="dataForm.bankCardNo" disabled placeholder="收款银行账号"></el-input>
          </el-form-item>
          <el-form-item  style="width:500px" label="银行名称">
            <el-input  v-model="dataForm.bankName" disabled placeholder="银行名称"></el-input>
          </el-form-item>
      </div>
      <div class="line-box">
        <el-form-item label="开户行所在省"  class="styW">
          <el-input v-model="dataForm.bankProName" disabled  placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="所在市"  class="styW">
          <el-input v-model="dataForm.bankCityName" disabled  placeholder="请输入"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="开户支行名称"  style="width:500px" >
            <el-input v-model="dataForm.brabankName" disabled  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="邮箱地址"  style="width:500px" >
            <el-input v-model="dataForm.email" disabled  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="现住地址"   class="sandh">
            <el-input v-model="dataForm.address" disabled placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="添加共借企业" prop="productCode">
          <el-button @click="addBorrow1">添加共借企业</el-button>
      </el-form-item>
      <el-card v-if="gjr1">
          <el-form v-loading="myLoading" :model="relationList" :rules="rules"
          :label-width="$i18n.locale === 'en-US' ? '140px' : '140px'"
          ref="relationList" >
            
         <div class="line-box">
          <el-form-item label="企业名称" prop="name"  class="styW">
              <el-input v-model="relationList.name"  placeholder="企业名称"></el-input>
            </el-form-item>
           
            <el-form-item label="统一社会信用代码" prop="idNo"  class="styW">
                <el-input v-model="relationList.idNo" placeholder="统一社会信用代码"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="mobile"  class="styW">
                <el-input v-model="relationList.mobile"  placeholder="联系电话" ></el-input>
            </el-form-item>
            <el-form-item label="地址/住址" prop="addr"  class="styW">
                <el-input v-model="relationList.addr"  placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址" prop="email"  class="styW">
                <el-input v-model="relationList.email" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
            <el-form-item label="操作" >
              <el-button @click="addCancel1">取消</el-button>
              <el-button @click="submitForm('relationList')" >添加</el-button>
            </el-form-item>
        </el-form>
      </el-card>

      <h3 class='h3' v-if="dataForm.relationList.length > 0">共借企业</h3>
      <div class="line-box">

     <div class="line-box">
      <div class="gjr" v-for="(item,index) in dataForm.relationList" :key="item.idNo" >
          <el-form-item class="styW" label="企业名称" :prop="'relationList.' + index + '.name'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
            <el-input v-model="item.name"   placeholder="企业名称"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="联系电话" :prop="'relationList.' + index + '.mobile'" :rules="{required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur'}">
              <el-input v-model="item.mobile"  placeholder="联系电话"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="统一社会信用代码" :prop="'relationList.' + index + '.idNo'" :rules="{ required: true,  pattern: /^(?:\d{6}(?:\d{8}(?:\d|X|x)?|((0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}))|[A-Z0-9]{18})$/, message: '请输入正确的证件号', trigger: 'blur' }">
              <el-input  v-model="item.idNo"   placeholder="统一社会信用代码"></el-input>
            </el-form-item>
          <el-form-item class="styW" label="地址/住址" :prop="'relationList.' + index + '.addr'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
              <el-input v-model="item.addr"  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item  class="styW" label="邮箱地址" :prop="'relationList.' + index + '.email'" :rules="{ required: true,type:'email', message: '请输入正确的邮箱', trigger: 'blur' }">
              <el-input v-model="item.email"  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="是否删除共借人" >
            <el-button @click="del(item.mobile)">删除</el-button>
          </el-form-item>
        </div>
      </div>
      </div>
    </div>

    <h3 class="h3">借款信息</h3>
    <div class="line-box">
      <el-form-item class="styW" label="借款产品" prop="loanApplyList[0].productCode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select class="sandh" v-model="dataForm.loanApplyList[0].productCode" @change="contractNum" clearable  placeholder="请选择" >
          <el-option
            v-for="item in borrowType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  class="styW" label="借款利率" prop="loanRate" >
          <el-input-number style="width:85%"  v-model="dataForm.loanRate"  :precision="2" :min="0"  :step="0.1" ></el-input-number>
            <span>  %<span class="font-max">/</span>{{  isShowPledge ? '年' : '年'}}  </span>
       </el-form-item>
      <!-- <el-form-item v-if="isShowPledge"  class="styW" label="贷款种类" prop="loanType" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select v-if="isLL" class="sandh" v-model="dataForm.loanType"  clearable placeholder="请选择" >
          <el-option
            v-for="item in loanTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <div class="line-box" style="width:100%">
      <el-form-item class="styW1" v-if="isShowPledge"  label="贷款详细用途" prop="loanApplyList[0].loanUsage" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select  class="sandh" v-model="dataForm.loanApplyList[0].loanUsage" clearable placeholder="请选择" >
          <el-option
            v-for="item in loanDetailed"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        
      </el-form-item>
      
      <el-form-item class="styW1" v-if="isLoanUsageText" label-width="0px" label="" prop="loanUsageText" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-input v-model="dataForm.loanUsageText"  placeholder="如为其他，必须写明具体用途"></el-input>
      </el-form-item>
    
    </div> -->
      <!-- <el-form-item v-if="isShowPledge" class="styW1" label="还款方式" prop="repaymentTypeCode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select class="sandh" v-model="dataForm.repaymentTypeCode" clearable placeholder="请选择" >
          <el-option
            v-for="item in repaymentTypeCode"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      
      <el-form-item class="styW" label="借款用途" prop="loanApplyList[0].loanUsage" :rules="{ required: true, pattern: /^[\u4E00-\u9FA5]+$/,message: '只能为中文' }">
          <el-input v-model="dataForm.loanApplyList[0].loanUsage" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item style="width: 420px;" class="styW" label="借款金额" prop="loanApplyList[0].loanAmount" :rules="[
      { required: true, message: '借款金额是必填项', trigger: 'blur' },
      { validator: validateNotInRange, trigger: ['blur', 'change'] }
    ]">
          <el-input style="width:85%" @blur="changeAmount" @focus="focusAmount" v-model="dataForm.loanApplyList[0].loanAmount" placeholder="请输入"></el-input>
         元
         <div class="loan_tip" v-if="loanLimitEnabled">
          <img src="../../../assets/img/waring.svg" alt="">
          <div >放款额度单笔{{loanAmountMin}}元起。若需试单，额度为1~{{testAmountLimit}}(元)。</div>
         </div>
         
      </el-form-item>
      <!-- <el-form-item v-if="!isShowPledge" class="styW" label="结息方式" prop="loanApplyList[0].interestTypeCode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select class="sandh" v-model="dataForm.loanApplyList[0].interestTypeCode" placeholder="请输入">
          <el-option
            v-for="(item,index) in interestTypeCode"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <div style="width: 1300px;">
        <div class="line-box">
          <el-form-item  class="styW" label="还款付息方式" prop="loanApplyList[0].repaymentMode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <el-select class="sandh" v-model="dataForm.loanApplyList[0].repaymentMode" placeholder="请输入">
            <el-option
              v-for="(item,index) in repaymentMode"
              :key="index"
              :label="item.label"
             :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="放款回单付款用途" prop="loanApplyList[0].postScript" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <div>
            <el-select  v-model="dataForm.loanApplyList[0].postScript" placeholder="请输入">
            <el-option
              v-for="(item,index) in receiptList"
              :key="index"
              :label="item.label"
             :value="item.label">
            </el-option>
          </el-select>
          <span @click="showReceipt = true" style="cursor: pointer;padding-left: 10px; font-size: 12px; color: #f59a23;">样例展示</span>
          </div>
        </el-form-item>
        </div>
      <div class="line-box">
        <el-form-item  class="styW" label="解决争议方式" prop="loanApplyList[0].disputeMode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select style="width: 270px;" class="sandh" v-model="dataForm.loanApplyList[0].disputeMode" placeholder="请输入">
          <el-option
            v-for="(item,index) in disputeMode"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        
        </el-form-item>
        <el-form-item style="position: relative;" v-if="dataForm.loanApplyList[0].disputeMode == '2'" class="styW" label="仲裁委" prop="loanApplyList[0].arbitrationCommittee" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
              <div class="arbitration">
                <el-input class="ar_input" v-model="dataForm.loanApplyList[0].arbitrationCommittee"  placeholder="请输入"></el-input>
                <span>仲裁委员会</span>
              </div>
              <div style="width: 480px;position: absolute; left: -94px;">
                <i class="el-icon-warning" style="color: rgb(244,143,32);font-size: 16px;margin-right: 4px;"></i>
                <span>示例：如“上海仲裁委员会”，填「上海」即可，无需填「上海仲裁委员会」</span>
              </div>
        </el-form-item>
        
      </div>
      <el-form-item  class="styW" style="width: 100%;">
        <div>
          
            <div style="font-weight: bold; position: relative;">诉讼解决:
              <img style="position: absolute;left: -14px; top: 13px;" src="../../../assets/img/mark.svg" alt="">
            </div>
            <p>原告可向下列其中一个有管辖权的人民法院提起诉讼: ① 贷款人住所地；②借款人住所地；③债权受让人住所地；④合同签订地。甲乙双方同意管辖法院可以采取简易程序开庭审理。</p>
            <div style="font-weight: bold;">仲裁解决:</div>
            <p>仲裁委员会仲裁解决，按照申请仲裁时该会现行有效的仲裁规则适用简易程序一人仲裁庭进行书面审理。仲裁裁决是终局的，对双方均有约束力。</p>
            <div style="font-weight: bold;">公证解决:</div>
            <p>赋予借款/担保合同强制执行效力公证解决，乙方同意就本合同下的所有借款向公证处申请赋予强制执行效力公证，在发生违约情况下，甲方可直接向公证处申请执行证书并向管辖人民法院申请强制执行。</p>
           
          </div>
      </el-form-item>
      </div>

     

      
      <!-- <el-form-item class="styW" label="逾期利率" prop="loanApplyList[0].overdueRate" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }" >
        <el-input-number class="sandh" v-model="dataForm.loanApplyList[0].overdueRate" :precision="2" :min="0" :step="0.1" :max="200"></el-input-number>
       </el-form-item> -->
       <div style="height:40px;margin-bottom:20px">
        <el-form-item  label="借款期限" prop="loanApplyList[0].initPeriod" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
          <div style="display: flex;position: relative;">
            <el-date-picker
                    style="display:block;width:400px"
                    v-model="dataForm.loanApplyList[0].initPeriod"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="getTimes()"
                    :picker-options="pickerOptions"
                    unlink-panels>
            </el-date-picker>
            <div style="margin-left: 30px;">{{ diffDays }} 天</div>
            <span v-if="diffDays < 3" style="font-size: 12px;color: red; position: absolute;bottom: -30px; left: 140px;">借款期限不能小于3天</span>
          </div>
      </el-form-item>
      </div>
      <el-form-item class="sandh" label="合同数量" prop="registerProvinceCode">
        <div  class="ht">
          <div>合同共 {{dataForm.relationList.length + (isShowPledge ? 4 : 2) }} 份</div>
          <div>甲方 {{isShowPledge ? '1' : dataForm.relationList.length + 1}} 份 乙方 {{!isShowPledge ? '1' : dataForm.relationList.length + 1}} 份 </div>
          <div v-if="isShowPledge">
            公证处、房屋登记机构各执1份
          </div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </el-form-item>

      <el-form-item class="styW" label="合同签订日期" prop="loanApplyList[0].createTime" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
        <el-date-picker
           class="sandh"
            v-model="dataForm.loanApplyList[0].createTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            >
          </el-date-picker>
      </el-form-item>
      <!-- <el-form-item v-if="!isShowPledge"  class="styW" label="借款合同签订地" prop="loanApplyList[0].signPlace" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-input v-model="dataForm.loanApplyList[0].signPlace" placeholder="请输入地点"></el-input>
      </el-form-item> -->
      <div style="width:100%; display: flex;align-items: center;"> 
        <el-form-item label="借款合同签订地"></el-form-item>
        <el-form-item style="position: relative;" label="" prop="loanSheng"  label-width="0px">
          <div class="selectArea">*</div>
          <el-select @change="selectCity" class="sandh" v-model="dataForm.loanSheng" filterable clearable placeholder="请选择省">
            <el-option
              v-for="(item,index) in shengList"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="position: relative;"   label="" prop="loanShi"  label-width="10px">
          <div class="selectArea">*</div>
          <el-select @change="selectCity" class="sandh" v-model="dataForm.loanShi" clearable filterable placeholder="请选择市">
            <el-option
              v-for="(item,index) in shiList"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item   prop="loanQu" label-width="10px" >
          <el-select @change="selectCity" class="sandh" v-model="dataForm.loanQu" clearable filterable placeholder="请选择区">
            <el-option
              v-for="(item,index) in quList"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="0px">
          （区根据需要选填）
        </el-form-item>
     </div>
    </div>
    <h3 class="h3" v-if="isShowPledge">抵押信息</h3>
    <div class="line-box" v-if="isShowPledge">
      <el-form-item label="抵押人"   class="styW">
          <el-input v-model="dataForm.custName" disabled placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号码"  class="styW">
          <el-input v-model="dataForm.idNo" disabled placeholder="证件号码"></el-input>
      </el-form-item>
      <el-form-item label="联系电话"  class="styW">
          <el-input v-model="dataForm.mobile" disabled placeholder="手机号" ></el-input>
      </el-form-item>     
    </div>
    <div class="line-box" v-if="isShowPledge">
      <el-form-item label="通讯地址" class="sandh">
          <el-input v-model="dataForm.address" disabled placeholder="请输入"></el-input>
      </el-form-item>
    </div>
    
    <div v-if="isShowPledge">
      <div v-for="(item,index) in dataForm.commonMortgage" :key="index">
        <div class="line-box">
          <el-form-item :label="'抵押人'+ (index+2)*1"   class="styW" :prop="'commonMortgage.' + index + '.name'" :rules="{ required: true, pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文', trigger: 'blur' }">
            <el-input v-model="item.name" disabled placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码"  class="styW" :prop="'commonMortgage.' + index + '.idNo'" :rules="{ required: true,  pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }">
            <el-input v-model="item.idNo" disabled placeholder="证件号码"></el-input>
          </el-form-item>
          <el-form-item label="联系电话"  class="styW" :prop="'commonMortgage.' + index + '.mobile'" :rules="{required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur'}">
            <el-input v-model="item.mobile"  placeholder="手机号" ></el-input>
          </el-form-item> 
        </div>
        <div class="line-box">
          <el-form-item label="通讯地址" class="sandh" :prop="'commonMortgage.' + index + '.addr'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
            <el-input v-model="item.addr"  placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <el-form-item class="styW" label="是否删除抵押人" >
          <el-button @click="delPledge(item.mobile)">删除</el-button>
        </el-form-item>
          
      </div>
    </div>
    <!-- 抵押人添加 -->
    <el-card v-if="dyr" style="margin-bottom: 20px;">
        <el-form v-loading="myLoading" :model="commonMortgage" :rules="rules"
        :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'"
         ref="commonMortgage" >
         <el-form-item label="身份证" prop="idNo" >
            <div class="tip_upload">
              <div>
                <div class="id-upload">
          
          <el-upload
            drag
            :action="uploadUrl"
            :on-success="handleSuccessFront"
            :on-remove="handleRemoveFront"
            :on-preview="handlePreviewFront"
            :before-upload="beforeUploadFront"
          >
            <img v-if="frontUrl" :src="frontUrl" class="avatar">
            <div v-else class="id-card">
              <div>
                <div class="title">头像面</div>
                <div>
                  <img src="../../../assets/img/头像面.png" alt=""  class="avatar">
                </div>
              </div>
              <div>
                  <div class="add">+</div>
                  <div>请上传身份证头像面图片</div>
                </div>
            </div>
          </el-upload>
          <!-- <i class="el-icon-delete deleteIcon"></i> -->
        </div>
        <div class="id-upload">
          <el-upload
            drag
            :action="uploadUrl"
            :on-success="handleSuccessBack"
            :on-remove="handleRemoveBack"
            :on-preview="handlePreviewBack"
            :before-upload="beforeUploadBack"
          >
            <img v-if="backUrl" :src="backUrl" class="avatar">
            <div v-else class="id-card">
              <div>
                <div class="title">国徽面</div>
                <div>
                  <img src="../../../assets/img/国徽面.png" alt=""  class="avatar">
                </div>
              </div>
              <div>
                  <div class="add">+</div>
                  <div>请上传身份证国徽面图片</div>
                </div>
            </div>
          </el-upload>
          <!-- <i class="el-icon-delete deleteIcon"></i> -->
        </div>
        
        <el-button type="primary" @click="idUpload(1)">确认上传</el-button>
              </div>
              <div class="tips">
                 1.请确保借款人身份证图片所有信息清晰可见，内容真实有效，无任何修改<br>
                 2.文件大小不超过3M，格式支持 ：jpg，jpeg，png，bmp <br>
                 3.图片建议分辨率为1024*768
              </div>
            </div>
         </el-form-item>
         <div class="line-box">
          <el-form-item label="抵押人" prop="name"  class="styW">
              <el-input v-model="commonMortgage.name" disabled  placeholder="上传身份证后自动识别"></el-input>
            </el-form-item>
           
            <el-form-item label="身份证号码" prop="idNo"  class="styW">
                <el-input v-model="commonMortgage.idNo" disabled placeholder="上传身份证后自动识别"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="mobile"  class="styW">
                <el-input v-model="commonMortgage.mobile"  placeholder="手机号" ></el-input>
            </el-form-item>
            <el-form-item label="通讯地址" prop="addr"  class="styW">
                <el-input v-model="commonMortgage.addr"  placeholder="请输入"></el-input>
            </el-form-item>
          </div>
            <el-form-item label="操作" >
              <el-button @click="addCancelPledger">取消</el-button>
              <el-button @click="submitForm1('commonMortgage')" >添加</el-button>
            </el-form-item>
        </el-form>
    </el-card>
    <el-form-item v-if="isShowPledge && dataForm.commonMortgage.length < 4 && dyr == false" label="">
          <el-button @click="addPledger" type="primary">添加抵押人</el-button>
      </el-form-item>
    <div class="line-box" v-if="isShowPledge">
      <el-form-item  class="sandh" label="抵押物产权证号"  prop="mortgageNo"  :rules="{ required: true,message: '不能为空' }">
        <el-input v-model="dataForm.mortgageNo" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item class="sandh" label="抵押物坐落" prop="mortgageAddress" :rules="{ required: true,message: '不能为空' }">
          <el-input v-model="dataForm.mortgageAddress" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="建筑面积(㎡)" prop="buildArea"  class="styW" :rules="{ required: true,message: '不能为空' }">
        <el-input-number class="sandh" v-model="dataForm.buildArea" :min="0"  ></el-input-number>
      </el-form-item>
      <el-form-item label="评估价值(万元)" prop="price"  class="styW" :rules="{ required: true,message: '不能为空' }">
        <el-input-number class="sandh" v-model="dataForm.price" :min="0"  ></el-input-number>
      </el-form-item>
      <el-form-item  class="styW" label="使用现状" prop="useCurrentSituation" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select style="width: 270px;" class="sandh" v-model="dataForm.useCurrentSituation" placeholder="请选择" clearable filterable>
          <el-option
            v-for="(item,index) in useStatusList"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>       
      </el-form-item>
      <div style="width:100%; display: flex;"> 
        <el-form-item  label="签署地" prop="sheng" >
          <el-select class="sandh" v-model="dataForm.sheng" filterable clearable placeholder="请选择">
            <el-option
              v-for="(item,index) in city"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="" prop="shi" label-width="10px" >
          <el-select class="sandh" v-model="dataForm.shi" clearable filterable placeholder="请选择">
            <el-option
              v-for="(item,index) in cityList"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
     </div>


      <!-- <el-form-item label="土地使用权面积(平方米)" label-width="171px"  class="styW" >
        <el-input-number class="sandh" v-model="dataForm.useArea" :min="0"  ></el-input-number>
      </el-form-item> -->
        
          <!-- <el-form-item class="sandh" label="抵押物其他详情"   >
            <el-input v-model="dataForm.mortgageAtt"   placeholder="请输入" ></el-input>
            
          </el-form-item> -->
     
      
    </div>
    </el-form>
    <el-dialog width="600px" :visible.sync="showReceipt" @close="showReceipt = false" style="z-index: 100; ">
      <img style="width: 100%;" src="../../../assets/img/receipt.png" alt="">
      <template slot="footer">
      <el-button type="primary" @click="showReceipt = false">关闭</el-button>
    </template>
     </el-dialog>
    <template slot="footer">
      <el-button @click="qx()">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" :disabled="isButton">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>

import debounce from 'lodash/debounce'
import  {arrCity} from '../../../utils/city'
import Cookies from "js-cookie";
export default {
  created(){

    arrCity.forEach(item => {
      this.city.push(...item.city.map(item => item))
      this.shengList.push(item.name)
      
    })
   this.$http.post(`/sys/dept/queryDeptInfo`).then(r=>{
      this.loanLimitEnabled = r.data.data.loanLimitEnabled
      this.testAmountLimit = r.data.data.testAmountLimit
      this.loanAmountMin = r.data.data.loanAmountMin
     
    })
    this.$http.get(`/sys/dict/data/list?dataType=interestTypeCode`).then(r=>{
      this.interestTypeCode = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
     
    })
    this.$http.get(`/sys/dict/data/list?dataType=disputeMode`).then(r=>{
      this.disputeMode = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
     
    })
    this.$http.get(`/sys/dict/data/list?dataType=repaymentMode`).then(r=>{
      this.repaymentMode = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
      console.log(222, this.repaymentMode);
     
    })
    this.$http.get(`/sys/dict/data/list?dataType=receipt_purpose`).then(r=>{
      this.receiptList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
     
    })
    this.$http.get(`/sys/dict/data/list?dataType=loanTypes`).then(r=>{
      this.loanTypes = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
   
    })
    this.$http.get(`/sys/dict/data/list?dataType=repaymentTypeCode`).then(r=>{
      this.repaymentTypeCode = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    
    })
    this.$http.get(`/sys/dict/data/list?dataType=loanDetailed`).then(r=>{
      this.loanDetailed = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []

    })

    this.$http.get('/loan/tproduct/page',{
      page: 1,
      limit: 1000,
    }).then(r => {
      this.borrowType = r.data.data.list.map(item => ({value:item.productCode,label:item.productName     
      }))
      console.log(11,r);
    })
   
  },
  data () {
    var myLoanRate = (rule, value, callback) => {
        if (typeof value == 'undefined') {
          return callback(new Error('必填项不能为空'));
        } else {
                if(value > 24){
                  return callback(new Error('年利率不能超过24%'));
              }
              if(value == 0){
                  return callback(new Error('年利率不能为0'));
              }
               callback();
          
        //  if(this.isShowPledge){
            
        //       if(value > 24){
        //           return callback(new Error(`${this.isShowPledge ? "年" : "yue"}利率不能超过${this.isShowPledge ? 24 : 2}%`));
        //       }
        //        callback();
        //  }else {
       
        //     if(value > 2){
            
        //      return callback(new Error(`${this.isShowPledge ? "年" : "月"}利率不能超过${this.isShowPledge ? 24 : 2}%`));
        //     }
        //      callback();
        //  }
          
          }
         
       
      };
    return { 
      loanLimitEnabled:false,
      testAmountLimit:'',
      loanAmountMin:'',
      showReceipt:false,   
      shengList:[],
      shiList:[],
      quList:[],
      diffDays:0,
      myLoading:false,
      frontUrl:null,
      backUrl:null,
      uploadUrl:`${window.SITE_CONFIG["apiURL"]}/api/loan/sign/upload?token=${Cookies.get("token")}`,
      mobile:'',
      isButton:false,
      disputeMode:[],
      repaymentMode:[],
      receiptList:[],
      interestTypeCode:[],
      loanTypes:[],
      loanDetailed:[],
      repaymentTypeCode:[],
      city:[],
      cityList:[],
      infoid:'',
      visible: false,
      dialogVisible:false,
      date:'',
      gjr:false,
      gjr1:false,
      dyr:false,
      borrowType:[
      ],
      isLL:true,
      rules:{},
      useStatusList:[
        { value:'自住',label:'自住' },
        { value:'空置',label:'空置' },
        { value:'租赁',label:'租赁' },
      ],
      // 共借人
      relationList:{
        "addr": "",
        "email": "",
        "idNo": "",
        "mobile": "",
        "name": "",
        frontUrl:null,
        backUrl:null,
      },
      // 抵押人
      commonMortgage:{
        "addr": "",
        "idNo": "",
        "mobile": "",
        "name": "",
        "frontUrl":null,
        "backUrl":null,
      },
    
       
      dataForm: {
        loanSheng:'',
        loanShi:'',
        loanQu:'',
        frontUrl:null,
        backUrl:null,
        "address": "",
        "areaCode": "",
        "cityCode": "",
        "custName": "",
        email:'',
        "id": '',
        "idNo": "",
        bankName:'',
        bankCardNo:'',
        // loanType:'',
        loanDetailed:'',
        // repaymentTypeCode:'',
        mortgageAddress:'',
        buildArea:'',
        // useArea:'',
        mortgageNo:'',
        price:'0',
        useCurrentSituation:'',        
        signAddress:'',
        // mortgageAtt:'',
        sheng:'',
        shi:'',
        "loanRate": '',
        loanUsageText:'',
        "loanApplyList": [
          {
            "agreementCode": "",
            "agreementConfirmTime": "",
            "applyStatus": "",
            "capitalPlatformCode": "",
            "contractRate": '',
            "contractSignTime": "",
            "createBy": "",
            "createTime": "",
            "custId": '',
            "custName": "",
            "id": '',
            "idNo": "",
            "initPeriod": '',
            "interestTypeCode": "",
            "disputeMode":"",
            "repaymentMode":"",
            "postScript":"",
            "arbitrationCommittee":"",
            "isOpen": "",
            "loanAmount": '',
            "loanAmountFee": '',
            "loanApplyTime": "",
            "loanCardNo": "",
            "loanCode": "",
            "loanEndTime": "",
            "loanName": "",
            "loanPeriod": '',
            "loanStartTime": "",
            "loanUsage": "",
            "mobile": "",
            "overdueRate": '',
            "periodUnitCode": "",
            "productCode": "",
            "remark": "",
            "updateBy": "",
            "updateTime": "",
            "version": '',
            "signPlace":"",
          }
        ],
    
        "mobile": "",
        "provinceCode": "",
        "registerAddress": "",
        "registerAreaCode": "",
        "registerCityCode": "",
        "registerProvinceCode": "",
        "relationList": [
        ],
        "commonMortgage":[],

	    },
       pickerOptions: {
        onPick({ maxDate, minDate }){
          console.log(2222,maxDate, minDate);
        },
        disabledDate(time) {
          // console.log(11111);
          
          // const startDate = this.dataForm.loanApplyList[0].initPeriod[0];
          // console.log(23,startDate);
          
          // if (!startDate) return false; // 没有选择开始日期时不禁用

          // // 计算开始日期后的三天
          // const threeDaysLater = new Date(startDate);
          // threeDaysLater.setDate(threeDaysLater.getDate() + 3);

          // // 禁用开始日期后的三天
          // return time > startDate && time <= threeDaysLater;
        }
      },
      
      dataRule :{
        loanRate:[{ required: true, validator:myLoanRate, trigger: 'blur' }],
        sheng: [ { required: true, message: this.$t('validate.required'), trigger: 'change' }],
        shi: [ { required: true, message: this.$t('validate.required'), trigger: 'change' }],
        loanSheng: [ { required: true, message: this.$t('validate.required'), trigger: 'change' }],
        loanShi: [ { required: true, message: this.$t('validate.required'), trigger: 'change' }],
        custCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        custName: [
          {required: true,message: '请输入用户名',trigger: 'blur'},{min: 2,max: 8,message: '长度在 2 到 8 个字符'},{pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文'}
        ],
        mobile: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的手机号码', trigger: 'blur' }
          ],
        bankCardNo: [
        { required: true, message: '请输入银行卡号',min: 12, max: 20, trigger: 'blur', },
        ],
        idNo: [
        { required: true, message: '请输入身份证号', trigger: 'blur' },
        { min: 15, max: 18, message: '请如实填写身份证号', trigger: 'blur' },
              {
                   required: true,
                   pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                   message: '请输入正确的身份证号码',
                   trigger: 'blur'
              }
        ],
      
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      
        bankName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        
        email: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
       
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
      
    }
  },
  computed: {
    isShowPledge () {
      console.log(this.dataForm.loanApplyList[0].productCode)
      return this.dataForm.loanApplyList[0].productCode == '2' ? true : false
    },
    isLoanUsageText(){
     return this.dataForm.loanApplyList[0].loanUsage == '其他（不含支付购房款等禁止或限制用途）'
    },
  },
  watch:{
    'dataForm.sheng':{
      handler(newVal,odlVal){
        console.log(newVal)
       
        this.$set(this.dataForm,'shi','')
        this.city.forEach(item =>{
        if(item.name == newVal){
          console.log(item)
         this.cityList = item.area
        }
      })
      },
      deep:true,
    },
    'dataForm.loanShi':{
      handler(newVal,odlVal){
        console.log(newVal)
       
        this.$set(this.dataForm,'loanQu','')
        this.city.forEach(item =>{
        if(item.name == newVal){
          console.log(item)
         this.quList = item.area
        }
      })
      },
      deep:true,
    },
    'dataForm.loanSheng':{
      handler(newVal,odlVal){
        console.log(111,newVal)
       
        this.$set(this.dataForm,'loanShi','')
        arrCity.forEach(item =>{
        if(item.name == newVal){
         this.shiList = item.city
        }
      })
      },
      deep:true,
    },
  },
  methods: {
    changeAmount(){
      this.dataForm.loanApplyList[0].loanAmount = this.dataForm.loanApplyList[0].loanAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").split('.')[0]
    },
    focusAmount(){
      if(typeof(this.dataForm.loanApplyList[0].loanAmount) == 'string'){
        this.dataForm.loanApplyList[0].loanAmount = Number(this.dataForm.loanApplyList[0].loanAmount.replace(/,/g, ''));
      }
      
    },
    validateNotInRange(rule, value, callback) {
      // if (value > 500 && value < 5000) {
      //   callback(new Error('放款额度单笔5000元起。若需试单，额度为1~500(元)'));
      // }else if(value < 0 || value == 0 ){
      //   callback(new Error('请输入正确的金额'));
      // } else {
      //   callback();
      // }
      if(value < 0 || value == 0 ){
        callback(new Error('请输入正确的金额'));
      } else {
        callback();
      }
    },
    selectCity(){
      this.dataForm.loanApplyList[0].signPlace = this.dataForm.loanSheng+'|'+this.dataForm.loanShi+'|'+this.dataForm.loanQu
      console.log(555,this.dataForm.loanApplyList[0].signPlace);
    },
    // 取消添加共借人
    addCancel(){
      this.gjr = false
      this.frontUrl = null
      this.backUrl = null
      this.relationList = {
        "addr": "",
        "email": "",
        "idNo": "",
        "mobile": "",
        "name": "",
      }
    },
    // 取消添加共借人
    addCancel1(){
      this.gjr1 = false
      this.relationList = {
        "addr": "",
        "email": "",
        "idNo": "",
        "mobile": "",
        "name": "",
      }
    },
    // 取消添加抵押人
    addCancelPledger(){
      this.frontUrl = null
      this.backUrl = null
      this.dyr = false
      this.commonMortgage = {
        "addr": "",
        "idNo": "",
        "mobile": "",
        "name": "",
        "frontUrl":"",
        "backUrl":"",
      }
    },
    // 添加共借人
    addBorrow(){
      this.frontUrl = null
      this.backUrl = null
      this.gjr = true
    },
     // 添加共借企业
     addBorrow1(){
      this.gjr1 = true
    },
    // 添加抵押人
    addPledger(){
      this.frontUrl = null
      this.backUrl = null
      this.dyr = true
    },
    // 图片上传成功
    handleSuccessFront(res, file) {
        this.frontUrl = res.data
        this.dataForm.frontUrl = res.data
        // this.relationList.frontUrl = res.data
        if(res.code == 500){
          this.$message.error(res.msg);
        }
        // console.log(111,res.data,this.frontUrl);
      },
    handleSuccessBack(res, file) {
        this.backUrl = res.data
        this.dataForm.backUrl = res.data
        // this.relationList.backUrl = res.data
        if(res.code == 500){
          this.$message.error(res.msg);
        }
        // console.log(222,res,this.backUrl);
    },
    beforeUploadFront(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt3M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、PNG 或 JPEG 格式!');
      }
   
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 3MB!');
      }

      return isJPG && isLt3M;
    },
    beforeUploadBack(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
      const isLt3M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、PNG 、JPEG、BMP 格式!');
      }
   
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 3MB!');
      }

      return isJPG && isLt3M;
    },
    // 图片删除
    handleRemoveFront(){
      this.frontUrl = null
    },
    handleRemoveBack(){
      this.backUrl = null
    },
    // 预览
    handlePreviewFront(){

    },
    handlePreviewBack(){

    },
    // 身份证识别
    idUpload(index){
      this.myLoading = true
      if(this.frontUrl == null){
        this.$message.error("请先上传身份证头像面图片");
        this.myLoading = false
      }else if(this.backUrl == null){
        this.$message.error("请上传身份证国徽面图片");
        this.myLoading = false
      }else{
        this.$http.post('/api/loan/sign/userCertificationAuth',{
        backUrl: this.backUrl,
        frontUrl:this.frontUrl
      }).then((res) => {
        this.myLoading = false
          console.log(23,res);
          if(res.data.code == 0){
            this.$message.success(res.data.message);
            if(index == 1){
              this.commonMortgage.name = res.data.data.name
              this.commonMortgage.idNo = res.data.data.idNo
            }else{
              this.relationList.name = res.data.data.name
              this.relationList.idNo = res.data.data.idNo
            }
            

          }else{
            this.$message.error(res.data.message);
          }
        })
      }
    },
    contractNum(r){
     this.dataForm.loanApplyList[0].loanUsage = ''
     this.dataForm.loanRate = 0
    },
    qx(){
      this.frontUrl = null
      this.backUrl = null
      this.gjr = false
      this.dyr = false
      this.diffDays = 0
      this.$emit('dataFormFS')
      this.dataForm = {
        brabankName:'',
        bankProName:'',
        bankCityName:'',
                  // repaymentTypeCode:'',
                  mortgageAddress:'',
                  // loanType:'',
                  mortgageNo:'',
                  buildArea:'',
                  // useArea:'',
                  price:'',
                  useCurrentSituation:'',
                  signAddress:'',
                  // mortgageAtt:'',
                  "address": "",
                  "areaCode": "",
                  "cityCode": "",
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  "loanRate": '',
                  "loanApplyList": [
                {
                  "agreementCode": "",
                  "agreementConfirmTime": "",
                  "applyStatus": "",
                 
                  bankName:'',
                  "capitalPlatformCode": "",
                  "contractRate": '',
                  "contractSignTime": "",
                  "createBy": "",
                  "createTime": "",
                  "custId": '',
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  "initPeriod": '',
                  "interestTypeCode": "",
                  "disputeMode":"",
                  "repaymentMode":"",
                  "postScript":"",
                  "arbitrationCommittee":"",
                  "isOpen": "",
                  "loanAmount": '',
                  "loanAmountFee": '',
                  "loanApplyTime": "",
                  "loanCardNo": "",
                  "loanCode": "",
                  "loanEndTime": "",
                  "loanName": "",
                  "loanPeriod": '',
                  "loanStartTime": "",
                  "loanUsage": "",
                  "mobile": "",
                  "overdueRate": '',
                  "periodUnitCode": "",
                  "productCode": "",
                  "remark": "",
                  "updateBy": "",
                  "updateTime": "",
                  "version": '',
                  "signPlace":"",
                }
              ],
          
              "mobile": "",
              "provinceCode": "",
              "registerAddress": "",
              "registerAreaCode": "",
              "registerCityCode": "",
              "registerProvinceCode": "",
              "relationList": [
              ],
              "commonMortgage":[],
	                  }
      this.dialogVisible = false
    },
    getFormData(){
      this.$http.get(`/loan/tcustbase/${this.infoid}`).then( r => {
        this.dataForm.loanApplyList[0].initPeriod = String(this.dataForm.loanApplyList[0].initPeriod)
        
        let loanApplyList = JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0]))
        this.dataForm.loanApplyList = loanApplyList
        let custName = r.data.data.custName
        let mobile = r.data.data.mobile
        let idNo = r.data.data.idNo
        let bankName = r.data.data.bankName
        let bankCardNo = r.data.data.bankCardNo
        this.dataForm.email = r.data.data.email
        this.dataForm.borrowerType = r.data.data.borrowerType
        this.dataForm.payeeType = r.data.data.payeeType
        this.dataForm.bankAcctname = r.data.data.bankAcctname
        this.dataForm.bankProName = r.data.data.bankProName
        this.dataForm.bankCityName = r.data.data.bankCityName
        this.dataForm.brabankName = r.data.data.brabankName
        let address = r.data.data.address
        this.dataForm = {
         ...this.dataForm,
         mobile,
         idNo,
         custName,
         address,
         id:'',
         bankCardNo:bankCardNo,
         bankName:bankName,
         loanApplyList:[{
          ...this.dataForm.loanApplyList,
          custId:this.infoid,
         }]

        } 
        this.dialogVisible = true
      })
    
    },
    // 删除共借人
    del(mobile){
      this.dataForm.relationList = this.dataForm.relationList.filter(item => item.mobile != mobile)
    },
  //  删除抵押人
  delPledge(mobile){
    this.dataForm.commonMortgage = this.dataForm.commonMortgage.filter(item => item.mobile != mobile)
  } ,
  // 添加抵押人
  submitForm1(commonMortgage) {
        this.$refs[commonMortgage].validate((valid) => {
          if (valid) {
            
                this.dyr = false
                // 添加成功刷新数据
                this.commonMortgage.mobile = this.commonMortgage.mobile.trim()
                this.commonMortgage.frontUrl = this.frontUrl
                this.commonMortgage.backUrl = this.backUrl
                this.dataForm
                 this.dataForm.commonMortgage.push(JSON.parse(JSON.stringify(this.commonMortgage)))
                 this.commonMortgage = {
                      "addr": "",
                      "idNo": "",
                      "mobile": "",
                      "name": "",
                      "frontUrl":"",
                      "backUrl":"",
                    }
                 this.$message({
                  message: '添加成功',
                  type: 'success'
                })
           
          } else {
          
            return false;
          }
        });
        
      },
  // 添加共借人
    submitForm(relationList) {
        this.$refs[relationList].validate((valid) => {
          if (valid) {
            
                this.gjr = false
                this.gjr1 = false
                // 添加成功刷新数据
                this.relationList.mobile = this.relationList.mobile.trim()
                this.relationList.frontUrl = this.frontUrl
                this.relationList.backUrl = this.backUrl
                 this.dataForm.relationList.push(JSON.parse(JSON.stringify(this.relationList)))
                 this.relationList = {
                      "addr": "",
                      "email": "",
                      "idNo": "",
                      "mobile": "",
                      "name": "",
                      "frontUrl":"",
                      "backUrl":"",
                    }
                 this.$message({
                  message: '添加成功',
                  type: 'success'
                })
           
          } else {
          
            return false;
          }
        });
        
      },
     
   
    getTimes(e){
      if(this.dataForm.loanApplyList[0].initPeriod){
        const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
        const firstDate = new Date(this.dataForm.loanApplyList[0].initPeriod[0]);
        const secondDate = new Date(this.dataForm.loanApplyList[0].initPeriod[1]);

        const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
        this.diffDays = diffDays
      }else{
        this.diffDays = 0
      }
      

      // if (this.date != null) {
      //     this.dataForm.startDate = this.date[0]
      //     this.dataForm.endDate = this.date[1]
      //   }else{
      //     this.dataForm.startDate =''
      //     this.dataForm.endDate = ''
      //   }
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    handleClose(tag) {
        this.tags.splice(this.tags.indexOf(tag), 1);
      },
    // 获取信息
    getInfo () {
      this.$http.get(`/loan/tcustbase?id=${this.dataForm.id}`).then(({ data: res }) => {
        // if (res.code !== 0) {
        //   return this.$message.error(res.msg)
        // }
        // this.dataForm = {
        //   ...this.dataForm,
        //   ...res.data
        // }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          
          if(this.diffDays < 3){
            this.$message.error('借款期限不能小于3天')
            return
          }
          let dataForm = {
                  "custId": JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].custId)) ,
                  "productCode":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].productCode))  ,
                  "loanUsage":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].loanUsage + (this.dataForm.loanUsageText ? ':' + this.dataForm.loanUsageText : '' )))   ,
                  "loanRate":JSON.parse(JSON.stringify(this.dataForm.loanRate))  ,
                  "interestTypeCode":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].interestTypeCode))  ,
                  "disputeMode":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].disputeMode)),
                  "repaymentMode":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].repaymentMode)),
                  "postScript":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].postScript)),
                  "arbitrationCommittee":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].arbitrationCommittee)),
                  "loanAmount":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].loanAmount))  ,
                  "overdueRate":JSON.parse(JSON.stringify( this.dataForm.loanApplyList[0].overdueRate)) ,
                  "loanStartTime":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].initPeriod[0]))  ,
                  "loanEndTime":JSON.parse(JSON.stringify( this.dataForm.loanApplyList[0].initPeriod[1])),
                  "contractSignTime":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].createTime)),
                  "bankCardNo":this.dataForm.bankCardNo,
                  "bankName":this.dataForm.bankName,
                  "relationList":JSON.parse(JSON.stringify(this.dataForm.relationList)),
                  "commonMortgage":JSON.parse(JSON.stringify(this.dataForm.commonMortgage)),
                  "signPlace":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].signPlace)),
                 
                  mortgageEntity:{
                    mortgageAddress:this.dataForm.mortgageAddress,
                    buildArea:this.dataForm.buildArea,
                    // useArea:this.dataForm.useArea,
                    mortgageNo:this.dataForm.mortgageNo,
                    price:this.dataForm.price,
                    useCurrentSituation:this.dataForm.useCurrentSituation,
                    signAddress:this.dataForm.sheng +'|'+ this.dataForm.shi,
                    // mortgageAtt:this.dataForm.mortgageAtt
                  },
                  repaymentTypeCode:this.dataForm.repaymentTypeCode,
                  // loanType: this.dataForm.loanType,
                  
              }
              dataForm.arbitrationCommittee = dataForm.arbitrationCommittee.replace(/仲裁委员会|仲裁委/gi, '');
              if(typeof dataForm.loanAmount == 'string'){
                dataForm.loanAmount = Number(dataForm.loanAmount.replace(/,/g, ''));
              }
             this.isButton = true
          this.$http.post('/loan/tloanapply',dataForm).then(r => {
             
            if(r.data.code == 0){
                this.diffDays = 0
                this.dataForm = {
                  // repaymentTypeCode:'',
                  // loanType:'',
                  mortgageNo:'',
                  buildArea:'',
                  // useArea:'',
                  price:'',
                  useCurrentSituation:'',
                  signAddress:'',
                  mortgageAddress:'',
                  // mortgageAtt:'',
                  "address": "",
                  "areaCode": "",
                  "cityCode": "",
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  "loanApplyList": [
                {
                  "agreementCode": "",
                  "agreementConfirmTime": "",
                  "applyStatus": "",
                  "bankCardNo": "",
                  bankName:'',
                  "capitalPlatformCode": "",
                  "contractRate": '',
                  "contractSignTime": "",
                  "createBy": "",
                  "createTime": "",
                  "custId": '',
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  "initPeriod": '',
                  "interestTypeCode": "",
                  "disputeMode":"",
                  "repaymentMode":"",
                  "postScript":"",
                  "arbitrationCommittee":"",
                  "isOpen": "",
                  "loanAmount": '',
                  "loanAmountFee": '',
                  "loanApplyTime": "",
                  "loanCardNo": "",
                  "loanCode": "",
                  "loanEndTime": "",
                  "loanName": "",
                  "loanPeriod": '',
                  "loanRate": '',
                  "loanStartTime": "",
                  "loanUsage": "",
                  "mobile": "",
                  "overdueRate": '',
                  "periodUnitCode": "",
                  "productCode": "",
                  "remark": "",
                 
                  "updateBy": "",
                  "updateTime": "",
                  "version": '',
                  "signPlace":""
                }
              ],
          
              "mobile": "",
              "provinceCode": "",
              "registerAddress": "",
              "registerAreaCode": "",
              "registerCityCode": "",
              "registerProvinceCode": "",
              "relationList": [
              ],
              "commonMortgage":[],
	                  }
                this.$message({
                  message: '添加成功',
                  type: 'success',
                })
               
                this.dialogVisible = false
                this.isButton = false
                this.$router.push({
                  path:"/loan-tloanapply",
                  query:{
                    data:this.mobile
                  }
                })
               
            }else{
              this.isButton = false
              this.$message({
                message:r.data.msg,
                type:'warning'
              })
            }
            
          })
          console.log('成功')
        }else{
          this.$message({
                  message: '校验失败',
                  type: 'error',
            })
        }
      
      })
    }, 1000, { 'leading': true, 'trailing': false })},
    
    
  
}


</script>

<style lang="scss" scoped>
  @import '../../../assets/css/passWord.css';
 .tj{
  border: 1px solid #ccc;
 }
//  .gjr{
//   border: 1px solid red;
//  }
 .ht{
  display: flex;
  justify-content: space-between;
 }
 .h3{
  margin: 20px 0;
 }
 .styW{
  width: 400px;
 }
 .styW1{
  width: 500px;
 }
 .tip_upload{
  display: flex;
  align-items: center;
}
.tips{
  margin: 0 0 50px 20px;
}
 .mylabel{
  width: 120px;

  overflow:hidden;
  text-overflow:ellipsis; 
  white-space:nowrap 
 }
.sandh{
  width: 100%;
}
.lv{
  height: 20px;
  font-size: 12px;
  color: rgb(224, 74, 74);
}
.font-max{
  display: inline-block;
  font-size: 19px;
  position: relative;
  top: 3px;
 }

 .el-input__inner{
  height: 41px;
 }

 .id-upload{
  display: flex;
  align-items: flex-end;
  .deleteIcon{
    font-size: 26px;
    margin: 20px;
  }
  .id-card{
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    margin: 20px 0;
    .add{
      font-weight: bold;
      font-size: 30px;
      color: #000;
    }
    .title{
      font-weight: bold;
      font-size: 24px;
      line-height: 60px;
      color: #333;
    }
  }
  .avatar{
    width: 100%;
    height: 100%;
  }
}
.selectArea{
  color: red;
  position: absolute;
  left: -8px;
  top: 0px;
}
.arbitration{
  display: flex;
  .ar_input{
    width: 140px;
    margin-right: 4px;
  }
}
.loan_tip{
  display: flex;
  align-items: center;
  color: #f08620;
  font-size: 12px;
  width: 350px;
  img{
    width: 14px;
    margin-right: 3px;
    
  }
}
</style>
